/*********************************************************************************************
 * Splide Lookbook tag
 *
 */
document.addEventListener('DOMContentLoaded', function () {
    var routineSections = document.querySelectorAll('[data-section-lookbook-id]');
    var scrollCounter = 0;

    routineSections.forEach(function (section) {
        var id = '.splide-lookbook-tag';
        var splideElem = section.querySelector(id);

        if (splideElem != null && splideElem.querySelectorAll(".splide__slide").length > 0) {
            mmSplideInit(splideElem, section);
        }
    });

    function mmSplideInit(splideElem, section) {
        var splideInstance = new Splide(splideElem, {
            type        : 'slide',
            arrows      : false,
            pagination  : false,
            gap         : '20px',
            fixedWidth  : 'fit-content',
            perMove     : 1,
            padding     : {
            },
            breakpoints : {
                768: {
                    focus   : 'center',
                }
            }
        }).mount();

        // Mise à jour lors des mouvements ou drag du carrousel
        splideInstance.on('moved', updateProgressBar);
        splideInstance.on('dragged', updateProgressBar);

        // Ajoute l'écouteur d'événement de défilement à splideElem
        splideElem.addEventListener('wheel', function (e) {
            // Ne pas empêcher le comportement par défaut si le défilement est vertical
            if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
                return;
            }

            // Empêche le comportement par défaut uniquement pour le défilement horizontal
            e.preventDefault();

            // Incrémente le compteur de défilements
            scrollCounter++;

            // Vérifie si le compteur atteint le seuil pour un mouvement
            if (scrollCounter >= 12) {
                // Réinitialise le compteur
                scrollCounter = 0;

                // Déplace la diapositive selon la direction du défilement horizontal
                if (e.deltaX < 0) {
                    splideInstance.go('<'); // Mouvement vers la gauche
                } else if (e.deltaX > 0) {
                    splideInstance.go('>'); // Mouvement vers la droite
                }
            }
        });
    }
});


document.addEventListener('DOMContentLoaded', () => {
    if (window.matchMedia("(max-width: 768px)").matches) {
        gsap.registerPlugin(ScrollTrigger);

        document.querySelectorAll('.mm-lookbook-articles-card').forEach((card) => {
            let container = card.querySelector('.mm-lookbook-articles-contener');
            let thumbnails = card.querySelectorAll('.mm-lookbook-articles-thumbnails');

            // Animation pour le conteneur principal
            ScrollTrigger.create({
                trigger: card,
                start: 'top 50%',
                end: 'bottom 50%',
                onEnter: () => {
                    container.style.top = '0';
                    container.style.transitionDelay = '0s';
                },
                onLeave: () => {
                    container.style.top = '140px';
                    container.style.transitionDelay = '.4s';
                },
                onEnterBack: () => {
                    container.style.top = '0';
                    container.style.transitionDelay = '0s';
                },
                onLeaveBack: () => {
                    container.style.top = '140px';
                    container.style.transitionDelay = '.4s';
                },
                // markers: true, 
                // Utile pour le debugging, à retirer en production
            });

            // Animation pour les vignettes
            thumbnails.forEach((thumbnail, index) => {
                let animationDelay = index * 0.15;

                ScrollTrigger.create({
                    trigger: card,
                    start: 'top 50%',
                    end: 'bottom 50%',
                    onEnter: () => {
                        thumbnail.style.opacity = '1';
                        thumbnail.style.transform = 'translateY(0)';
                        container.style.transitionDelay = '0s';
                    },
                    onLeave: () => {
                        thumbnail.style.opacity = '0';
                        thumbnail.style.transform = 'translateY(20px)';
                        container.style.transitionDelay = '.4s';
                    },
                    onEnterBack: () => {
                        thumbnail.style.opacity = '1';
                        thumbnail.style.transform = 'translateY(0)';
                        container.style.transitionDelay = '0s';
                    },
                    onLeaveBack: () => {
                        thumbnail.style.opacity = '0';
                        thumbnail.style.transform = 'translateY(20px)';
                        container.style.transitionDelay = '.4s';
                    },
                    // markers: true, 
                    // Utile pour le debugging, à retirer en production
                });
            });
        });
    }
});

document.addEventListener("DOMContentLoaded", function() {
    // Sélectionner tous les liens avec la classe .mm-blog-tag-filter
    document.querySelectorAll('.mm-blog-tag-filter').forEach(function(link) {
        // Vérifier si le lien possède la classe "active"
        if (link.classList.contains('active')) {
            // Ajouter la classe "active-li" au parent <li>
            link.closest('li').classList.add('active-li');
        }
    });
});
